let debug_bootstrapped = false;

export async function bootDebug(): Promise<void> {
  if (debug_bootstrapped) return;
  debug_bootstrapped = true;
  console.debug("[bootstrap/debug] debug tooling disabled (no-op)");
}
